import { Button } from '@/components/ui/button'
import { ErrorState } from '@/components/ui/error-state'
import { useNavigate } from '@tanstack/react-router'
import { ArrowLeft, Home, SearchX } from 'lucide-react'

export function NotFoundPage() {
	const navigate = useNavigate()

	const handleGoHome = () => {
		navigate({ to: '/' })
	}

	const handleGoBack = () => {
		if (window.history.length > 1) {
			window.history.back()
		} else {
			handleGoHome()
		}
	}

	return (
		<ErrorState
			title='Page Not Found'
			message="The page you're looking for doesn't exist or has been moved."
			showSupportEmail={false}
			containerClassName='min-h-screen w-screen overflow-hidden'
			icon={SearchX}
			tone='neutral'
			actions={
				<>
					<Button onClick={handleGoHome} size='sm' className='text-body'>
						<Home className='size-(--icon-standalone)' />
						Go Home
					</Button>
					<Button onClick={handleGoBack} size='sm' variant='outline' className='text-body'>
						<ArrowLeft className='size-(--icon-standalone)' />
						Go Back
					</Button>
				</>
			}
		/>
	)
}
